<template>
<div v-if='show' class='odp_model'>

	<template v-for='(item,index) in table'>
		<o-vData v-if="item['data']" 
				 :key='item.id' 
				 :lineIndex='index' 
				 :lineData='item' 
				 :func_input='inputChange' 
				 :func_click='func_SPEC_S'
				 />
		<o-vDataMulti v-else-if="item['data_multi']" 
				 :key='item.id' 
				 :lineIndex='index' 
				 :lineData='item' 
				 :func_input='inputChange' 
				 :func_click='func_SPEC_S'
				 />
		<o-vDataAfter v-else-if="item['data_after']" 
				 :key='item.id' 
				 :lineIndex='index' 
				 :lineData='item' 
				 :func_input='inputChange' 
				 :func_click='func_SPEC_S' 
				 />
	</template>

</div>
</template>
<script>
import {gain_produce} from '@/seal/proCardSet';

export default {
	name: 'bzbg',//便笺表格
	components: {},
	props: {},
	data() {
		return {
			pid: 'pidcards_bzbg',
			show: false,
			table: {},
		}
	},
	methods: {
		showChange() {

			// 获取表单
			const produce = gain_produce(this['pid']);
			if (produce['table']) {
				this.table = produce['table'];
			} else {
				return;
			}

			this.show = true;
		},
		closeChange() {
			this.show = false;
		},
		//输入框完成事件
		inputChange(event) {
			const params = this.func_tidyParams();
			this.$parent.func_quotation(this.pid, params);
		},
		//点击产品规格-汇总
		func_SPEC_S(event) {
			const type = event.currentTarget.dataset.type;
			const index = event.currentTarget.dataset.index;
			const seq = event.currentTarget.dataset.seq;
			if (!this.table[index] || !this.table[index][type]) return;
			switch (type) {
				case 'data': {
					//当前点击行的所有参数规格
					let data = this.table[index][type];
					if (data[seq]['choose'] && data[seq]['type']!=='select') return;

					// 点击区域属-'下拉框'
					if (data[seq]['type'] === 'select') {
						const select_index = event.currentTarget.dataset.select_index;
						if (select_index) {
							data[seq]['name'] = data[seq]['select_data'][select_index]['name'];
							data[seq]['value'] = data[seq]['select_data'][select_index]['value'];
						}
					}

					// 切换已选中的'下拉框'的内容时-不需要执行
					if (!data[seq]['choose']) {
						for (let i in data) {
							if (data[i]['choose']) {
								data[i]['choose'] = false;
								data[seq]['choose'] = true;
								break;
							}
						}
					}

					break;
				}
				case 'data_multi': {
					const level = event.currentTarget.dataset.level;
					const select_index = event.currentTarget.dataset.select_index;
					let data = this.table[index][type];
					if (!level) return;

					data[seq]['name'] = data[seq]['select_data'][select_index]['name'];
					data[seq]['value'] = data[seq]['select_data'][select_index]['value'];
					if (level === '1') {
						// 切换二级内容
						data[1]['select_data'] = this.table[index]['multi_list'][select_index];
						data[1]['name'] = data[1]['select_data'][0]['name'];
						data[1]['value'] = data[1]['select_data'][0]['value'];
					}
					break;
				}
				case 'data_after': {
					const se = event.currentTarget.dataset.se;
					const select_index = event.currentTarget.dataset.select_index;
					let data = this.table[index][type];
					if (data[seq]['must'] && data[seq]['data'][se]['choose']) return;

					let in_data = data[seq]['data'];

					if (select_index !== undefined) {
						in_data[se]['name'] = in_data[se]['select_data'][select_index]['name'];
						in_data[se]['value'] = in_data[se]['select_data'][select_index]['value'];
					}

					if (data[seq]['must']) {
						// 当前行为-必选
						for (let i in in_data) {
							if (in_data[i]['choose']) {
								in_data[i]['choose'] = false;
								in_data[se]['choose'] = true;
								break;
							}
						}
					} else {
						// 当前行为-非必选
						if (in_data[se]['choose'] && select_index===undefined) {
							in_data[se]['choose'] = false;
						} else {
							for (let i in in_data) {
								if (in_data[i]['choose']) {
									in_data[i]['choose'] = false;
									break;
								}
							}
							in_data[se]['choose'] = true;
						}
					}

					break;
				}
				default: {
					return;
				}
			}

			// 整合规格参数，请求报价
			const params = this.func_tidyParams();
			this.$parent.func_quotation(this.pid, params);
		},
		// 整理参数
		func_tidyParams() {
			let result = {
				need_QQoffer: false,//需QQ另行计价
				string: '便笺表格-',//报价内容
				hjg: [
				],
				api: 'getprice9',
			};

			for (let i in this.table) {
				// 当前行
				const line_name = i;
				// 当前行类型
				let line_type = this.table[i]['data'] ? 'data' : (this.table[i]['data_multi'] ? 'data_multi' : this.table[i]['data_after'] ? 'data_after' : false);
					if (!line_type) return;

				const data = this.table[i][line_type];
				switch (line_type) {
					// 面板一(普通)
					case ('data'): {
						const container = this.table[i]['container'];
						if (!container) return;
						for (let j in data) {
							// 行中选中的块
							if (data[j]['choose']) {

								if (line_name==='p_yinshuashuliang' && data[j]['type']==='custom1' && (parseInt(data[j]['value'])%50 !== 0)) {
									data[j]['value'] = 5;
								}

								// 文字内容提示
								if (line_name === 'p_shuliang') {
									result['string'] += (data[j]['value'] + '本-');
								} else {
									result['string'] += (data[j]['name'] + '-');
								}

								// 常规处理
								if (container.constructor['name'] === 'String') {
									result[container] = data[j]['value'];
								} else if (container.constructor['name'] === 'Array') {
									for (let c in container) {
										result[container[c]] = data[j]['value'][c];
									}
								}
								break;
							}
						}
						break;
					}
					// 面板二(多行)
					case ('data_multi'): {
						const container = this.table[i]['container'];
						if (!container) return;
						for (let c in container) {
							// 文字内容提示
							result['string'] += (data[c]['name'] + '-');

							result[container[c]] = data[c]['value'];
						}
						break;
					}
					// 面板二(后道工序)
					case ('data_after'): {
						for (let j in data) {
							const in_data = data[j]['data'];
							for (let k in in_data) {

								if (in_data[k]['choose']) {

									// 文字内容提示
									result['string'] += (in_data[k]['name'] + '-');

									const container = data[j]['container'];
									if (!container) return;
									if (container === 'hjg') {
										result['hjg'].push(in_data[k]['value']);
									} else if (container.constructor['name'] === 'String') {
										result[container] = in_data[k]['value'];
									} else if (container.constructor['name'] === 'Array') {
										for (let c in container) {
											if (container[c] === 'hjg') {
												result['hjg'].push(in_data[k]['value'][c]);
											} else {
												result[container[c]] = in_data[k]['value'][c];
											}
										}
									}
									break;
								}
							}
						}
						break;
					}
					default: return;
				}
			}
			//result['cailiao'] = '联单';
			delete result['yongzhi'];
			if (result['string'].endsWith('-')) {
				result['string'] = result['string'].substring(0, result['string'].length-1);
			}

			return result;
		},
	},
	mounted() {
	}
}
</script>
<style src='@/style/orderProduct.css'></style>




// WEBPACK FOOTER //
// src/pages/order/v2020/bzbg.vue